import * as React from "react";
import { createFileRoute, Navigate } from "@tanstack/react-router";

const SettingsIndex: React.FC = () => {
  return <Navigate to="/settings/account" replace />;
};

export const Route = createFileRoute("/settings/")({
  component: SettingsIndex,
});
